export default __webpack_public_path__ + "static/media/messge.40fb623e.svg";